/**
 * Owner training videos. Global App Settings override these defaults.
 * Keep defaults in sync with everhostadmin trainingVideos.js.
 */
export const DEFAULT_EDIT_SECTION_VIDEO_URL = "";

export const DEFAULT_NEARBY_VIDEO_URL =
  "https://www.youtube.com/watch?v=h5SjlZAvLmo";

export const DEFAULT_ADVANCED_TRAINING_VIDEO_URL = "";

export function configuredVideoUrl(value, fallback) {
  const configured = String(value || "").trim();
  return configured || fallback || "";
}

export function resolveEditSectionTrainingVideoUrl(appSettings = {}) {
  return configuredVideoUrl(
    appSettings.editSectionTrainingVideoUrl,
    DEFAULT_EDIT_SECTION_VIDEO_URL,
  );
}

export function resolveNearbyTrainingVideoUrl(appSettings = {}) {
  return configuredVideoUrl(
    appSettings.nearbyTrainingVideoUrl,
    DEFAULT_NEARBY_VIDEO_URL,
  );
}

export function resolveAdvancedTrainingVideoUrl(appSettings = {}) {
  return configuredVideoUrl(
    appSettings.advancedTrainingVideoUrl,
    DEFAULT_ADVANCED_TRAINING_VIDEO_URL,
  );
}
